import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
  inject,
} from '@angular/core';
import { DashboardService } from '../../dashboard.service';
import { SessionStorageService } from '../../../services/session-storage.service';
import { DateTime } from 'luxon';
import { Platform } from '@angular/cdk/platform';
import Highcharts from 'highcharts';
import { Router } from '@angular/router';
import { EnvironmentService } from '../../../services/environment.service';
import { NgxLoadingModule } from 'ngx-loading';
import { MatCardModule } from '@angular/material/card';
import { HighchartsChartComponent } from 'highcharts-angular';
import { MatButtonModule } from '@angular/material/button';
import {
  GridModule,
  KENDO_GRID_EXCEL_EXPORT,
} from '@progress/kendo-angular-grid';

@Component({
  selector: 'app-system-usage',
  templateUrl: './systemUsage.component.html',
  styleUrls: ['./systemUsage.component.scss'],
  imports: [
    NgxLoadingModule,
    MatCardModule,
    HighchartsChartComponent,
    MatButtonModule,
    GridModule,
    KENDO_GRID_EXCEL_EXPORT,
  ],
  providers: [],
})
export class SystemUsageComponent implements OnInit, OnChanges {
  private dbs = inject(DashboardService);
  private ss = inject(SessionStorageService);
  private pltfrm = inject(Platform);
  private route = inject(Router);
  private envSvc = inject(EnvironmentService);

  @ViewChild('usageGrid', { static: false }) usageGrid;
  @Input() mode;
  @Input() solutionId;
  @Input() start;
  @Input() end;
  @Input() selectedUnit;

  private environment;
  private baseUrl: string;
  Highcharts: typeof Highcharts = Highcharts;
  loading = false;
  data;
  viewMode = 'chart';
  chart = { data: null, legend: null };
  noData = true;
  insufficientDateRange = false;
  noDataMessage = '';

  ngOnInit() {
    this.environment = this.envSvc.get();
    this.baseUrl = this.environment.apiBase;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes.solutionId && changes.solutionId.previousValue !== undefined) ||
      (changes.end && changes.end.previousValue === null) ||
      changes.selectedUnit
    ) {
      this.getChart();
    }
  }

  getChart() {
    this.loading = true;
    this.chart = { data: null, legend: null };

    const start = DateTime.fromJSDate(new Date(this.start), { zone: 'utc' })
      .startOf('day')
      .toISO();
    const end = DateTime.fromJSDate(new Date(this.end), { zone: 'utc' })
      .endOf('day')
      .toISO();

    this.dbs
      .getUsageChart(this.selectedUnit, start, end, this.solutionId)
      .subscribe({
        next: x => {
          if (x.charts[0].Data.series.length > 0) {
            this.chart.data = x.charts[0].Data;
            this.noData = false;
            this.noDataMessage = '';
            if (this.chart.data.chart.width) {
              delete this.chart.data.chart.width;
            }
            this.chart.legend = x.charts[0].Legend;
          } else {
            const timeDiffCheck = DateTime.fromJSDate(new Date(this.end), {
              zone: 'utc',
            })
              .endOf('day')
              .diff(
                DateTime.fromJSDate(new Date(this.start), {
                  zone: 'utc',
                }).startOf('day'),
                'months'
              ).months;

            this.chart = { data: null, legend: null };
            this.noData = true;

            if (timeDiffCheck < 1) {
              this.noDataMessage = 'insufficient';
            } else {
              this.noDataMessage = 'noData';
            }
          }
          this.loading = false;
        },
        error: error => {
          this.loading = false;
          console.warn(error);
        },
      });
  }

  navToReporting() {
    this.ss.set('defaultReportingTab', 'Unit Usage');
    this.route.navigate([`/reporting`]);
  }
}
